var _defs, _path, _circle, _path2, _path3, _path4, _path5, _rect, _polygon, _polygon2, _polygon3, _path6, _rect2, _path7, _path8, _g, _g2, _path9, _path10, _path11, _path12, _rect3, _path13, _circle2, _circle3, _circle4, _circle5, _path14, _path15, _path16, _polygon4, _g3, _g4, _g5, _g6, _path17, _path18, _path19, _circle6, _circle7, _circle8, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _path20, _path21, _g20, _g21, _path22, _path23, _g22, _g23, _path24, _path25, _path26, _g24, _circle9, _g25, _path27, _g26, _path28, _path29, _g27, _line, _path30, _ellipse, _ellipse2, _line2, _path31, _ellipse3, _ellipse4, _line3, _path32, _ellipse5, _ellipse6, _line4, _path33, _ellipse7, _ellipse8, _path34, _polygon5, _polygon6, _polygon7, _polygon8, _path35, _path36, _path37, _g28, _polygon9, _polygon10, _path38, _path39, _polygon11, _polygon12, _polygon13, _path40, _path41, _path42, _path43, _path44, _circle10, _path45, _path46, _path47, _path48;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f21aae09-1e91-4712-bd71-b66e0e1639c2",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1015.56,
    height: 783.53,
    viewBox: "0 0 815.87 803.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e08ae246-9923-473c-893a-bafa52b5bffd",
    x1: 774.33,
    y1: 714.58,
    x2: 774.33,
    y2: 48.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4b6995c3-17d2-4db7-90cf-5d4e31ed6999",
    x1: 695,
    y1: 234.7,
    x2: 695,
    y2: 201.95,
    xlinkHref: "#e08ae246-9923-473c-893a-bafa52b5bffd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9e932041-c94c-45e6-b53a-e57935e29db0",
    x1: 706.85,
    y1: 253.9,
    x2: 706.85,
    y2: 238.74,
    gradientTransform: "translate(488.88 -470.23) rotate(53.86)",
    xlinkHref: "#e08ae246-9923-473c-893a-bafa52b5bffd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd9a810c-fedf-4ace-8d1e-2c1929a73b1a",
    x1: 729.4,
    y1: 248.37,
    x2: 729.4,
    y2: 216.62,
    xlinkHref: "#e08ae246-9923-473c-893a-bafa52b5bffd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9624227a-2ea3-4e3b-8c57-5965d2ecc536",
    x1: 723.22,
    y1: 265.97,
    x2: 723.22,
    y2: 253.15,
    gradientTransform: "translate(340.62 -407.22) rotate(40.41)",
    xlinkHref: "#e08ae246-9923-473c-893a-bafa52b5bffd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c883fe55-a579-4c62-8ce1-1e582fcc781b",
    x1: 654.48,
    y1: 234.7,
    x2: 654.48,
    y2: 202.92,
    xlinkHref: "#e08ae246-9923-473c-893a-bafa52b5bffd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7821e36d-e922-407b-8b27-47670f0c2923",
    x1: 654.44,
    y1: 253.9,
    x2: 654.44,
    y2: 238.74,
    xlinkHref: "#e08ae246-9923-473c-893a-bafa52b5bffd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0d2b84db-cd79-4f8e-ada2-f5ace2bd0550",
    x1: 684.88,
    y1: 374.01,
    x2: 684.88,
    y2: 236.83,
    xlinkHref: "#e08ae246-9923-473c-893a-bafa52b5bffd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f8a08d85-c1d3-485a-86b7-8b3df5ed85e7",
    x1: 378.45,
    y1: 517.7,
    x2: 698.21,
    y2: 517.7,
    xlinkHref: "#e08ae246-9923-473c-893a-bafa52b5bffd"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "love is in the air") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M854.78,248.45l.43-.06c-13.46-41.21-42.45-40.56-50.2-39.6A34.61,34.61,0,0,0,794,207h-.68v-9.4l1.06-.41a17.1,17.1,0,0,0-.92-4.53A46.66,46.66,0,0,0,813.9,176.5a52.57,52.57,0,0,0-10.38-81,10.12,10.12,0,0,0,.67-.84,10.06,10.06,0,0,0-5.28-18.17,20.13,20.13,0,0,0-31.34-23.39,20.13,20.13,0,0,1,29.58,17.77c0,.22,0,.44,0,.66a20.13,20.13,0,1,0-39,7.4,10.07,10.07,0,0,0-6.66,14.74,52.57,52.57,0,0,0-12.82,83.62,46.67,46.67,0,0,0,19,15V207a34.57,34.57,0,0,0-11.52,2.1s-36.53-8.54-52.15,39.28h0c-6.61,17.52-11.77,43.9-13.32,83.38,0,0,2.93,31.16,50.26,1.69l2.16,26.4h.38v8.94H733l.38.75v.24c-38.25,33-23.68,309.91-23.68,309.91l21.07-51.76c1.86,20,.29,42.72-.79,54.24l-1.33,0-1.59,24.55a4.31,4.31,0,0,0,4.28,4.85H763.9a2.23,2.23,0,0,0,2-3.23l-5.64-11.28a33.22,33.22,0,0,1-3.5-15.63L759.66,557l7.51-18.45,27.33-46.25,4.37,187.91a33.22,33.22,0,0,1-3.5,15.63l-5.64,11.28a2.23,2.23,0,0,0,2,3.23h32.54a4.3,4.3,0,0,0,3.52-1.83l.76,6h0l-.76-6a4.29,4.29,0,0,0,.76-3l-1.59-23.32-1.22-.09c-1.31-13.56-3.65-45.94,1-68.68a499.8,499.8,0,0,0,8.6-66.69l5.19-77.48.82,0,.28-5.19,1.21.06s15.14-61.58-23.16-94.41H819l.48-.95h-1.32v-8.95h1.91l1.77-24.47c44.5,26.76,46.19-3.62,46.19-3.62C866.53,292.33,861.37,266,854.78,248.45ZM806.09,87.61c0,.18,0,.36,0,.55a10.07,10.07,0,0,0-8.36-9.35q.29-.5.56-1A10.07,10.07,0,0,1,806.09,87.61ZM711.8,311.84l13.37-47.65,3.23,39.41Zm112.32-7.46,2.54-35.25L842.45,313Z",
    transform: "translate(-192.07 -48.47)",
    opacity: 0.5,
    fill: "url(#e08ae246-9923-473c-893a-bafa52b5bffd)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 583.76,
    cy: 102.14,
    r: 50.3,
    fill: "#f55f44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M824.16,675.23s-5.45-43.62.3-71.8a478.19,478.19,0,0,0,8.23-63.81l6.58-98.22-46.52,8.72,5.05,217.21",
    transform: "translate(-192.07 -48.47)",
    fill: "#fda57d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M797.8,667.33a31.78,31.78,0,0,1-3.35,15l-5.39,10.79a2.14,2.14,0,0,0,1.91,3.09h31.13a4.13,4.13,0,0,0,4.09-4.64l-1.52-22.31",
    transform: "translate(-192.07 -48.47)",
    fill: "#333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M731.16,676.4s5.45-43.62-.3-71.8a478.19,478.19,0,0,1-8.23-63.81l-6.58-98.22,46.52,8.72-5.05,217.21",
    transform: "translate(-192.07 -48.47)",
    fill: "#fda57d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M757.52,668.51a31.78,31.78,0,0,0,3.35,15l5.39,10.79a2.14,2.14,0,0,1-1.91,3.09H733.22a4.13,4.13,0,0,1-4.09-4.64l1.52-23.49",
    transform: "translate(-192.07 -48.47)",
    fill: "#333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 543.1,
    y: 302.19,
    width: 81.14,
    height: 31.41,
    fill: "#fda57d"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "633.16 643.96 633.16 643.97 634.13 651.73 634.13 651.73 633.16 643.96"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "601.75 415.66 646.37 417.03 647.2 401.6 600.69 410.32 601.75 415.66",
    opacity: 0.05
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "569.71 415.66 525.09 417.03 524.26 401.6 570.77 410.32 569.71 415.66",
    opacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M818.14,360.79H734.8L725.53,247.7a33.15,33.15,0,0,1,33.15-33.15h34.47A33.15,33.15,0,0,1,826.3,247.7Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#fbe1e5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 566.24,
    y: 137.1,
    width: 34.19,
    height: 47.01,
    rx: 9.6,
    ry: 9.6,
    fill: "#fda57d"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M734.8,369.34,764,426.56H784.9V458l55,2.62s14.49-58.92-22.16-90.33Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#fbe1e5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M817.58,369.34l-29.16,57.22,21.79,32.9-42.73,72.33-55,135s-14-265.14,22.69-296.55Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#fbe1e5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M736.33,235.52a33.36,33.36,0,0,1,1.46-5.17,33.07,33.07,0,0,0-11.2,24.83l3.16,38.53Z",
    transform: "translate(-192.07 -48.47)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M814.9,247.27a33.36,33.36,0,0,0-1.46-5.17,33.07,33.07,0,0,1,11.2,24.83l-3.16,38.53Z",
    transform: "translate(-192.07 -48.47)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M840.52,234.19c11,13.74,21.25,42.18,23.51,99.72,0,0-2.62,47.12-89-31.41l-2.62-52.83h0a1.91,1.91,0,0,1,2.3-1.88A10.47,10.47,0,0,1,782.88,258v31.41l56.63,26.5L814.33,246C811.66,230.91,830.93,222.19,840.52,234.19Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#fda57d"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M801.82,216.56s35-8.17,49.89,37.58L817,258.75Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#fbe1e5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M713.7,228.45c-12.84,10.75-26.42,38.26-29.05,105.47,0,0,4.38,46.64,90.76-31.89l.85-52.35h0a1.91,1.91,0,0,0-2.3-1.88A10.47,10.47,0,0,0,765.79,258v31.41L714.5,314.85,735.21,241C737.36,228.9,723.15,220.53,713.7,228.45Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#fda57d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M747.28,216.56s-35-8.17-49.89,37.58l35.28,4.08Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#fbe1e5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 582.27,
    y: 200.14,
    width: 1.07,
    height: 53.42,
    opacity: 0.05
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M777,208.35a44.35,44.35,0,0,0,16.53-3.19,16.38,16.38,0,0,0-16.34-15.32h-1.4a16.39,16.39,0,0,0-16.32,14.91A44.34,44.34,0,0,0,777,208.35Z",
    transform: "translate(-192.07 -48.47)",
    opacity: 0.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 583.85,
    cy: 111.11,
    r: 44.5,
    fill: "#fda57d"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 568.78,
    cy: 52.91,
    r: 9.63,
    fill: "#f55f44"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 603.02,
    cy: 52.91,
    r: 9.63,
    fill: "#f55f44"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 584.83,
    cy: 36.86,
    r: 19.26,
    fill: "#f55f44"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M797.23,89.61a9.59,9.59,0,0,0-5.37,1.64,9.63,9.63,0,0,1,8.61,17.06,9.63,9.63,0,0,0-3.23-18.69Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f55f44"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M780.1,62.86a19.18,19.18,0,0,0-12.25,4.4,19.26,19.26,0,0,1,21.29,31.87,19.26,19.26,0,0,0-9-36.27Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f55f44"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M743.72,119.57s5.35,35.31,72.77,16.05l-33.17-28.89Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f55f44"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "567.51 500.2 540.99 570.12 540.99 572.53 567.51 505.02 567.51 500.2",
    opacity: 0.05
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 779.65,
    y: 270.64,
    width: 1.48,
    height: 8.39,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 971.72,
    y: 319.11,
    width: 1.48,
    height: 8.39,
    transform: "translate(1103.69 -697.62) rotate(90)",
    fill: "#47e6b1"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 429.65,
    y: 453.64,
    width: 1.48,
    height: 8.39,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 621.72,
    y: 502.11,
    width: 1.48,
    height: 8.39,
    transform: "translate(936.69 -164.62) rotate(90)",
    fill: "#47e6b1"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.61,
    y: 518.41,
    width: 1.48,
    height: 8.39,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.68,
    y: 566.88,
    width: 1.48,
    height: 8.39,
    transform: "translate(677.42 224.18) rotate(90)",
    fill: "#47e6b1"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 446.81,
    y: 544.42,
    width: 1.48,
    height: 8.39,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.88,
    y: 592.89,
    width: 1.48,
    height: 8.39,
    transform: "translate(1044.64 -91.01) rotate(90)",
    fill: "#47e6b1"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M749.92,808.27a1.81,1.81,0,0,1-1-2.19.87.87,0,0,0,0-.2h0a.91.91,0,0,0-1.63-.6h0a.87.87,0,0,0-.1.18,1.81,1.81,0,0,1-2.19,1l-.2,0h0a.91.91,0,0,0-.6,1.63h0a.87.87,0,0,0,.18.1,1.81,1.81,0,0,1,1,2.19.87.87,0,0,0,0,.2h0a.91.91,0,0,0,1.63.6h0a.87.87,0,0,0,.1-.18,1.81,1.81,0,0,1,2.19-1l.2,0h0a.91.91,0,0,0,.6-1.63h0A.87.87,0,0,0,749.92,808.27Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#4d8af0",
    opacity: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M981.53,508.08a1.81,1.81,0,0,1-1-2.19.87.87,0,0,0,0-.2h0a.91.91,0,0,0-1.63-.6h0a.87.87,0,0,0-.1.18,1.81,1.81,0,0,1-2.19,1l-.2,0h0a.91.91,0,0,0-.6,1.63h0a.87.87,0,0,0,.18.1,1.81,1.81,0,0,1,1,2.19.87.87,0,0,0,0,.2h0a.91.91,0,0,0,1.63.6h0a.87.87,0,0,0,.1-.18,1.81,1.81,0,0,1,2.19-1l.2,0h0a.91.91,0,0,0,.6-1.63h0A.87.87,0,0,0,981.53,508.08Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#4d8af0",
    opacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M347.86,352.62a1.81,1.81,0,0,1-1-2.19.87.87,0,0,0,0-.2h0a.91.91,0,0,0-1.63-.6h0a.87.87,0,0,0-.1.18,1.81,1.81,0,0,1-2.19,1l-.2,0h0a.91.91,0,0,0-.6,1.63h0a.87.87,0,0,0,.18.1,1.81,1.81,0,0,1,1,2.19.87.87,0,0,0,0,.2h0a.91.91,0,0,0,1.63.6h0a.87.87,0,0,0,.1-.18,1.81,1.81,0,0,1,2.19-1l.2,0h0a.91.91,0,0,0,.6-1.63h0A.87.87,0,0,0,347.86,352.62Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#4d8af0",
    opacity: 0.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 812.9,
    cy: 183.82,
    r: 2.96,
    fill: "#f55f44",
    opacity: 0.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.85,
    cy: 411.21,
    r: 2.96,
    fill: "#4d8af0",
    opacity: 0.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 692.86,
    cy: 336.94,
    r: 2.96,
    fill: "#f55f44",
    opacity: 0.5
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M499.4,86.64A10.89,10.89,0,0,0,485.2,88a11.13,11.13,0,0,0,.44,15.51L499.22,117a2.27,2.27,0,0,0,3.21,0l13.5-13.58a11.13,11.13,0,0,0,.35-15.51,10.89,10.89,0,0,0-14.21-1.24A2.29,2.29,0,0,1,499.4,86.64Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f55f44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.91,116.44a2,2,0,0,0,0,1.9,8.78,8.78,0,0,1,.53.88c.35.87-.26,1.82-.88,2.53-.39.45-.83,1.06-.57,1.6a2,2,0,0,0,.46.52,3.35,3.35,0,0,1-1.28,5.58",
    transform: "translate(-192.07 -48.47)",
    fill: "none",
    stroke: "#f55f44",
    strokeMiterlimit: 10
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M940.4,167.64A10.89,10.89,0,0,0,926.2,169a11.13,11.13,0,0,0,.44,15.51L940.22,198a2.27,2.27,0,0,0,3.21,0l13.5-13.58a11.13,11.13,0,0,0,.35-15.51,10.89,10.89,0,0,0-14.21-1.24A2.29,2.29,0,0,1,940.4,167.64Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f55f44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.91,197.44a2,2,0,0,0,0,1.9,8.78,8.78,0,0,1,.53.88c.35.87-.26,1.82-.88,2.53-.39.45-.83,1.06-.57,1.6a2,2,0,0,0,.46.52,3.35,3.35,0,0,1-1.28,5.58",
    transform: "translate(-192.07 -48.47)",
    fill: "none",
    stroke: "#f55f44",
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.4,632.64A10.89,10.89,0,0,0,225.2,634a11.13,11.13,0,0,0,.44,15.51L239.22,663a2.27,2.27,0,0,0,3.21,0l13.5-13.58a11.13,11.13,0,0,0,.35-15.51,10.89,10.89,0,0,0-14.21-1.24A2.29,2.29,0,0,1,239.4,632.64Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f55f44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.91,662.44a2,2,0,0,0,0,1.9,8.78,8.78,0,0,1,.53.88c.35.87-.26,1.82-.88,2.53-.39.45-.83,1.06-.57,1.6a2,2,0,0,0,.46.52,3.35,3.35,0,0,1-1.28,5.58",
    transform: "translate(-192.07 -48.47)",
    fill: "none",
    stroke: "#f55f44",
    strokeMiterlimit: 10
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.4,119.64A10.89,10.89,0,0,0,207.2,121a11.13,11.13,0,0,0,.44,15.51L221.22,150a2.27,2.27,0,0,0,3.21,0l13.5-13.58a11.13,11.13,0,0,0,.35-15.51,10.89,10.89,0,0,0-14.21-1.24A2.29,2.29,0,0,1,221.4,119.64Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f55f44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.91,149.44a2,2,0,0,0,0,1.9,8.78,8.78,0,0,1,.53.88c.35.87-.26,1.82-.88,2.53-.39.45-.83,1.06-.57,1.6a2,2,0,0,0,.46.52,3.35,3.35,0,0,1-1.28,5.58",
    transform: "translate(-192.07 -48.47)",
    fill: "none",
    stroke: "#f55f44",
    strokeMiterlimit: 10
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M572.4,524.64A10.89,10.89,0,0,0,558.2,526a11.13,11.13,0,0,0,.44,15.51L572.22,555a2.27,2.27,0,0,0,3.21,0l13.5-13.58a11.13,11.13,0,0,0,.35-15.51,10.89,10.89,0,0,0-14.21-1.24A2.29,2.29,0,0,1,572.4,524.64Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f55f44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.91,554.44a2,2,0,0,0,0,1.9,8.78,8.78,0,0,1,.53.88c.35.87-.26,1.82-.88,2.53-.39.45-.83,1.06-.57,1.6a2,2,0,0,0,.46.52,3.35,3.35,0,0,1-1.28,5.58",
    transform: "translate(-192.07 -48.47)",
    fill: "none",
    stroke: "#f55f44",
    strokeMiterlimit: 10
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.4,279.64A10.89,10.89,0,0,0,574.2,281a11.13,11.13,0,0,0,.44,15.51L588.22,310a2.27,2.27,0,0,0,3.21,0l13.5-13.58a11.13,11.13,0,0,0,.35-15.51,10.89,10.89,0,0,0-14.21-1.24A2.29,2.29,0,0,1,588.4,279.64Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f55f44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.91,309.44a2,2,0,0,0,0,1.9,8.78,8.78,0,0,1,.53.88c.35.87-.26,1.82-.88,2.53-.39.45-.83,1.06-.57,1.6a2,2,0,0,0,.46.52,3.35,3.35,0,0,1-1.28,5.58",
    transform: "translate(-192.07 -48.47)",
    fill: "none",
    stroke: "#f55f44",
    strokeMiterlimit: 10
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.4,257.64A10.89,10.89,0,0,0,314.2,259a11.13,11.13,0,0,0,.44,15.51L328.22,288a2.27,2.27,0,0,0,3.21,0l13.5-13.58a11.13,11.13,0,0,0,.35-15.51,10.89,10.89,0,0,0-14.21-1.24A2.29,2.29,0,0,1,328.4,257.64Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f55f44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.91,287.44a2,2,0,0,0,0,1.9,8.78,8.78,0,0,1,.53.88c.35.87-.26,1.82-.88,2.53-.39.45-.83,1.06-.57,1.6a2,2,0,0,0,.46.52,3.35,3.35,0,0,1-1.28,5.58",
    transform: "translate(-192.07 -48.47)",
    fill: "none",
    stroke: "#f55f44",
    strokeMiterlimit: 10
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.19,
    y: 583,
    width: 3,
    height: 17,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.26,
    y: 631.47,
    width: 3,
    height: 17,
    transform: "translate(1031.66 7.74) rotate(90)",
    fill: "#47e6b1"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 791.19,
    y: 508,
    width: 3,
    height: 17,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 983.26,
    y: 556.47,
    width: 3,
    height: 17,
    transform: "translate(1357.66 -468.26) rotate(90)",
    fill: "#47e6b1"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 181.19,
    y: 44,
    width: 3,
    height: 17,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.26,
    y: 92.47,
    width: 3,
    height: 17,
    transform: "translate(283.66 -322.26) rotate(90)",
    fill: "#47e6b1"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 713.19,
    y: 226,
    width: 3,
    height: 17,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 905.26,
    y: 274.47,
    width: 3,
    height: 17,
    transform: "translate(997.66 -672.26) rotate(90)",
    fill: "#47e6b1"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.19,
    y: 343,
    width: 3,
    height: 17,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.26,
    y: 391.47,
    width: 3,
    height: 17,
    transform: "translate(500.66 58.74) rotate(90)",
    fill: "#47e6b1"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.19,
    y: 646,
    width: 3,
    height: 17,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.26,
    y: 694.47,
    width: 3,
    height: 17,
    transform: "translate(796.66 368.74) rotate(90)",
    fill: "#47e6b1"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M658.36,143.08a3.67,3.67,0,0,1-2-4.44,1.77,1.77,0,0,0,.08-.41h0a1.84,1.84,0,0,0-3.31-1.22h0a1.77,1.77,0,0,0-.2.36,3.67,3.67,0,0,1-4.44,2,1.77,1.77,0,0,0-.41-.08h0a1.84,1.84,0,0,0-1.22,3.31h0a1.77,1.77,0,0,0,.36.2,3.67,3.67,0,0,1,2,4.44,1.77,1.77,0,0,0-.08.41h0a1.84,1.84,0,0,0,3.31,1.22h0a1.77,1.77,0,0,0,.2-.36,3.67,3.67,0,0,1,4.44-2,1.77,1.77,0,0,0,.41.08h0a1.84,1.84,0,0,0,1.22-3.31h0A1.77,1.77,0,0,0,658.36,143.08Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#4d8af0",
    opacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M960.36,378.08a3.67,3.67,0,0,1-2-4.44,1.77,1.77,0,0,0,.08-.41h0a1.84,1.84,0,0,0-3.31-1.22h0a1.77,1.77,0,0,0-.2.36,3.67,3.67,0,0,1-4.44,2,1.77,1.77,0,0,0-.41-.08h0a1.84,1.84,0,0,0-1.22,3.31h0a1.77,1.77,0,0,0,.36.2,3.67,3.67,0,0,1,2,4.44,1.77,1.77,0,0,0-.08.41h0a1.84,1.84,0,0,0,3.31,1.22h0a1.77,1.77,0,0,0,.2-.36,3.67,3.67,0,0,1,4.44-2,1.77,1.77,0,0,0,.41.08h0a1.84,1.84,0,0,0,1.22-3.31h0A1.77,1.77,0,0,0,960.36,378.08Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#4d8af0",
    opacity: 0.5
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.65,
    y: 144.64,
    width: 1.48,
    height: 8.39,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.72,
    y: 193.11,
    width: 1.48,
    height: 8.39,
    transform: "translate(221.69 -67.62) rotate(90)",
    fill: "#47e6b1"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.81,
    y: 274.42,
    width: 1.48,
    height: 8.39,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.88,
    y: 322.89,
    width: 1.48,
    height: 8.39,
    transform: "translate(414.64 -1.01) rotate(90)",
    fill: "#47e6b1"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M301.92,192.27a1.81,1.81,0,0,1-1-2.19.87.87,0,0,0,0-.2h0a.91.91,0,0,0-1.63-.6h0a.87.87,0,0,0-.1.18,1.81,1.81,0,0,1-2.19,1l-.2,0h0a.91.91,0,0,0-.6,1.63h0a.87.87,0,0,0,.18.1,1.81,1.81,0,0,1,1,2.19.87.87,0,0,0,0,.2h0a.91.91,0,0,0,1.63.6h0a.87.87,0,0,0,.1-.18,1.81,1.81,0,0,1,2.19-1l.2,0h0a.91.91,0,0,0,.6-1.63h0A.87.87,0,0,0,301.92,192.27Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#4d8af0",
    opacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M225.53,382.08a1.81,1.81,0,0,1-1-2.19.87.87,0,0,0,0-.2h0a.91.91,0,0,0-1.63-.6h0a.87.87,0,0,0-.1.18,1.81,1.81,0,0,1-2.19,1l-.2,0h0a.91.91,0,0,0-.6,1.63h0a.87.87,0,0,0,.18.1,1.81,1.81,0,0,1,1,2.19.87.87,0,0,0,0,.2h0a.91.91,0,0,0,1.63.6h0a.87.87,0,0,0,.1-.18,1.81,1.81,0,0,1,2.19-1l.2,0h0a.91.91,0,0,0,.6-1.63h0A.87.87,0,0,0,225.53,382.08Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#4d8af0",
    opacity: 0.5
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 35.19,
    y: 382,
    width: 3,
    height: 17,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.26,
    y: 430.47,
    width: 3,
    height: 17,
    transform: "translate(475.66 161.74) rotate(90)",
    fill: "#47e6b1"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.19,
    y: 116,
    width: 3,
    height: 17,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 563.26,
    y: 164.47,
    width: 3,
    height: 17,
    transform: "translate(545.66 -440.26) rotate(90)",
    fill: "#47e6b1"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M204.36,252.08a3.67,3.67,0,0,1-2-4.44,1.77,1.77,0,0,0,.08-.41h0a1.84,1.84,0,0,0-3.31-1.22h0a1.77,1.77,0,0,0-.2.36,3.67,3.67,0,0,1-4.44,2,1.77,1.77,0,0,0-.41-.08h0a1.84,1.84,0,0,0-1.22,3.31h0a1.77,1.77,0,0,0,.36.2,3.67,3.67,0,0,1,2,4.44,1.77,1.77,0,0,0-.08.41h0a1.84,1.84,0,0,0,3.31,1.22h0a1.77,1.77,0,0,0,.2-.36,3.67,3.67,0,0,1,4.44-2,1.77,1.77,0,0,0,.41.08h0a1.84,1.84,0,0,0,1.22-3.31h0A1.77,1.77,0,0,0,204.36,252.08Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#4d8af0",
    opacity: 0.5
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M836.36,769.08a3.67,3.67,0,0,1-2-4.44,1.77,1.77,0,0,0,.08-.41h0a1.84,1.84,0,0,0-3.31-1.22h0a1.77,1.77,0,0,0-.2.36,3.67,3.67,0,0,1-4.44,2,1.77,1.77,0,0,0-.41-.08h0a1.84,1.84,0,0,0-1.22,3.31h0a1.77,1.77,0,0,0,.36.2,3.67,3.67,0,0,1,2,4.44,1.77,1.77,0,0,0-.08.41h0a1.84,1.84,0,0,0,3.31,1.22h0a1.77,1.77,0,0,0,.2-.36,3.67,3.67,0,0,1,4.44-2,1.77,1.77,0,0,0,.41.08h0a1.84,1.84,0,0,0,1.22-3.31h0A1.77,1.77,0,0,0,836.36,769.08Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#4d8af0",
    opacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M290.36,511.08a3.67,3.67,0,0,1-2-4.44,1.77,1.77,0,0,0,.08-.41h0a1.84,1.84,0,0,0-3.31-1.22h0a1.77,1.77,0,0,0-.2.36,3.67,3.67,0,0,1-4.44,2,1.77,1.77,0,0,0-.41-.08h0a1.84,1.84,0,0,0-1.22,3.31h0a1.77,1.77,0,0,0,.36.2,3.67,3.67,0,0,1,2,4.44,1.77,1.77,0,0,0-.08.41h0a1.84,1.84,0,0,0,3.31,1.22h0a1.77,1.77,0,0,0,.2-.36,3.67,3.67,0,0,1,4.44-2,1.77,1.77,0,0,0,.41.08h0a1.84,1.84,0,0,0,1.22-3.31h0A1.77,1.77,0,0,0,290.36,511.08Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#4d8af0",
    opacity: 0.5
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 770.61,
    y: 744.41,
    width: 1.48,
    height: 8.39,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 962.68,
    y: 792.88,
    width: 1.48,
    height: 8.39,
    transform: "translate(1568.42 -214.82) rotate(90)",
    fill: "#47e6b1"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 783.85,
    cy: 637.21,
    r: 2.96,
    fill: "#4d8af0",
    opacity: 0.5
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 764.19,
    y: 569,
    width: 3,
    height: 17,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 956.26,
    y: 617.47,
    width: 3,
    height: 17,
    transform: "translate(1391.66 -380.26) rotate(90)",
    fill: "#47e6b1"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M890.53,608.08a1.81,1.81,0,0,1-1-2.19.87.87,0,0,0,0-.2h0a.91.91,0,0,0-1.63-.6h0a.87.87,0,0,0-.1.18,1.81,1.81,0,0,1-2.19,1l-.2,0h0a.91.91,0,0,0-.6,1.63h0a.87.87,0,0,0,.18.1,1.81,1.81,0,0,1,1,2.19.87.87,0,0,0,0,.2h0a.91.91,0,0,0,1.63.6h0a.87.87,0,0,0,.1-.18,1.81,1.81,0,0,1,2.19-1l.2,0h0a.91.91,0,0,0,.6-1.63h0A.87.87,0,0,0,890.53,608.08Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#4d8af0",
    opacity: 0.5
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 700.19,
    y: 608,
    width: 3,
    height: 17,
    fill: "#47e6b1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 892.26,
    y: 656.47,
    width: 3,
    height: 17,
    transform: "translate(1366.66 -277.26) rotate(90)",
    fill: "#47e6b1"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M955.36,737.08a3.67,3.67,0,0,1-2-4.44,1.77,1.77,0,0,0,.08-.41h0a1.84,1.84,0,0,0-3.31-1.22h0a1.77,1.77,0,0,0-.2.36,3.67,3.67,0,0,1-4.44,2,1.77,1.77,0,0,0-.41-.08h0a1.84,1.84,0,0,0-1.22,3.31h0a1.77,1.77,0,0,0,.36.2,3.67,3.67,0,0,1,2,4.44,1.77,1.77,0,0,0-.08.41h0a1.84,1.84,0,0,0,3.31,1.22h0a1.77,1.77,0,0,0,.2-.36,3.67,3.67,0,0,1,4.44-2,1.77,1.77,0,0,0,.41.08h0a1.84,1.84,0,0,0,1.22-3.31h0A1.77,1.77,0,0,0,955.36,737.08Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#4d8af0",
    opacity: 0.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M614.36,771.08a3.67,3.67,0,0,1-2-4.44,1.77,1.77,0,0,0,.08-.41h0a1.84,1.84,0,0,0-3.31-1.22h0a1.77,1.77,0,0,0-.2.36,3.67,3.67,0,0,1-4.44,2,1.77,1.77,0,0,0-.41-.08h0a1.84,1.84,0,0,0-1.22,3.31h0a1.77,1.77,0,0,0,.36.2,3.67,3.67,0,0,1,2,4.44,1.77,1.77,0,0,0-.08.41h0a1.84,1.84,0,0,0,3.31,1.22h0a1.77,1.77,0,0,0,.2-.36,3.67,3.67,0,0,1,4.44-2,1.77,1.77,0,0,0,.41.08h0a1.84,1.84,0,0,0,1.22-3.31h0A1.77,1.77,0,0,0,614.36,771.08Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#4d8af0",
    opacity: 0.5
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M680.64,234.36a7.43,7.43,0,0,0,3.22-.75,7.2,7.2,0,0,0,1.49.16c3.79,0,7.12-3,9-7.47,1.21,4.35,3.9,7.51,7.43,8.1a7.43,7.43,0,0,0,3.3-.2,7.2,7.2,0,0,0,1.45.41c5.78,1,11.64-5.26,13.11-13.92s-2-16.48-7.81-17.45a7.43,7.43,0,0,0-3.3.2,7.2,7.2,0,0,0-1.45-.41c-4.66-.79-9.38,3.12-11.79,9.2-1.52-6-5.39-10.28-9.92-10.28a7.43,7.43,0,0,0-3.22.75,7.2,7.2,0,0,0-1.49-.16c-5.86,0-10.61,7.12-10.61,15.91S674.78,234.36,680.64,234.36Z",
    transform: "translate(-192.07 -48.47)",
    opacity: 0.1,
    fill: "url(#4b6995c3-17d2-4db7-90cf-5d4e31ed6999)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 707.28,
    cy: 246.08,
    rx: 9.09,
    ry: 4.55,
    transform: "matrix(0.59, -0.81, 0.81, 0.59, -100.65, 623.67)",
    opacity: 0.1,
    fill: "url(#9e932041-c94c-45e6-b53a-e57935e29db0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.91,218.51a7.43,7.43,0,0,0-3.26-.57,7.2,7.2,0,0,0-1.31-.73c-5.39-2.29-12.55,2.41-16,10.49s-1.85,16.5,3.54,18.79a7.43,7.43,0,0,0,3.26.57,7.2,7.2,0,0,0,1.31.73c5.39,2.29,12.55-2.41,16-10.49S743.3,220.8,737.91,218.51Z",
    transform: "translate(-192.07 -48.47)",
    opacity: 0.1,
    fill: "url(#bd9a810c-fedf-4ace-8d1e-2c1929a73b1a)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 723.52,
    cy: 259.13,
    rx: 9.09,
    ry: 4.55,
    transform: "translate(-187.43 482.41) rotate(-40.41)",
    opacity: 0.1,
    fill: "url(#9624227a-2ea3-4e3b-8c57-5965d2ecc536)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.76,234.6a7.2,7.2,0,0,0,1.45-.41,7.43,7.43,0,0,0,3.3.2c5.78-1,9.27-8.79,7.81-17.45S660,202,654.21,203a7.15,7.15,0,0,0-1.32.36l-.16,0a7.42,7.42,0,0,0-3.27-.2c-5.78,1-9.27,8.79-7.81,17.45S649,235.58,654.76,234.6Z",
    transform: "translate(-192.07 -48.47)",
    opacity: 0.1,
    fill: "url(#c883fe55-a579-4c62-8ce1-1e582fcc781b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.68,243.4c-3-4.05-9-4.66-9-4.66s-1.27,6,1.69,10,7,6.14,9,4.66S660.64,247.46,657.68,243.4Z",
    transform: "translate(-192.07 -48.47)",
    opacity: 0.1,
    fill: "url(#7821e36d-e922-407b-8b27-47670f0c2923)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.71,267.94a18.05,18.05,0,0,1-6-.81,15.31,15.31,0,0,0,.73-6c-.31-5-5.1-8.79-5.1-8.79a16.64,16.64,0,0,0-3.28,5.18,10.56,10.56,0,0,0-2.22-.2,41,41,0,0,0-4.64.29,13.33,13.33,0,0,0-.32-7.69c-1.29-4.22-5.71-6.71-6.77-7.25a16.7,16.7,0,0,0-1-5.85s-5.89,1.61-8.13,6.1-2.25,9,0,10.16c1.85.93,4.65-.77,6.84-3.91a9.62,9.62,0,0,0,.37,3.41,14.56,14.56,0,0,0,3.27,5.88A57.28,57.28,0,0,1,682,259.65c1.54-1.65,1.31-5.67-.68-9.65-2.25-4.49-8.13-6.1-8.13-6.1s-2.25,5.67,0,10.16a15.42,15.42,0,0,0,3.53,4.72,21.59,21.59,0,0,1-3.73-1.45,20.41,20.41,0,0,0-4.19-1.52,17.23,17.23,0,0,0,1.34-3.22c1.47-4.8-1.69-10-1.69-10s-5.54,2.56-7,7.37a16.12,16.12,0,0,0-.74,5,53.54,53.54,0,0,0-14.23,2.35C683.59,326.28,662.37,374,662.37,374h31.82C673,315.67,736.62,267.94,720.71,267.94Z",
    transform: "translate(-192.07 -48.47)",
    opacity: 0.1,
    fill: "url(#0d2b84db-cd79-4f8e-ada2-f5ace2bd0550)"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 491.12,
    y1: 279.9,
    x2: 491.12,
    y2: 181.23,
    fill: "none",
    stroke: "#3ad29f",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M685.5,203.73a7.27,7.27,0,0,0-3.15.73,7.05,7.05,0,0,0-1.46-.16c-5.74,0-10.39,7-10.39,15.58s4.65,15.58,10.39,15.58a7.27,7.27,0,0,0,3.15-.73,7.05,7.05,0,0,0,1.46.16c5.74,0,10.39-7,10.39-15.58S691.24,203.73,685.5,203.73Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f55f44"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 688.1,
    cy: 245.86,
    rx: 8.9,
    ry: 4.45,
    transform: "translate(-31.6 702.89) rotate(-63.43)",
    fill: "#3ad29f"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 677.56,
    cy: 252.78,
    rx: 4.45,
    ry: 8.9,
    transform: "translate(-233.58 281.23) rotate(-26.57)",
    fill: "#3ad29f"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 496.34,
    y1: 279.03,
    x2: 512.75,
    y2: 181.74,
    fill: "none",
    stroke: "#3ad29f",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M711.41,205a7.27,7.27,0,0,0-3.23.2,7.05,7.05,0,0,0-1.42-.4c-5.66-1-11.4,5.15-12.83,13.63s2,16.14,7.65,17.09a7.27,7.27,0,0,0,3.23-.2,7.05,7.05,0,0,0,1.42.4c5.66,1,11.4-5.15,12.83-13.63S717.07,205.94,711.41,205Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f55f44"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 706.97,
    cy: 246.95,
    rx: 8.9,
    ry: 4.45,
    transform: "translate(-101.48 623.77) rotate(-53.86)",
    fill: "#3ad29f"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 695.43,
    cy: 252.03,
    rx: 4.45,
    ry: 8.9,
    transform: "translate(-235.36 165.74) rotate(-16.99)",
    fill: "#3ad29f"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 494.02,
    y1: 285.29,
    x2: 532.61,
    y2: 194.48,
    fill: "none",
    stroke: "#3ad29f",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M737,220a7.27,7.27,0,0,0-3.19-.56,7.05,7.05,0,0,0-1.28-.72C727.2,216.43,720.2,221,716.83,229s-1.81,16.16,3.47,18.4a7.27,7.27,0,0,0,3.19.56,7.05,7.05,0,0,0,1.28.72c5.28,2.24,12.29-2.36,15.65-10.28S742.24,222.19,737,220Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f55f44"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 722.87,
    cy: 259.73,
    rx: 8.9,
    ry: 4.45,
    transform: "translate(-187.97 482.13) rotate(-40.41)",
    fill: "#3ad29f"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 710.47,
    cy: 261.99,
    rx: 4.45,
    ry: 8.9,
    transform: "translate(-206.9 -4.07) rotate(-3.54)",
    fill: "#3ad29f"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 481.3,
    y1: 279.03,
    x2: 464.88,
    y2: 181.74,
    fill: "none",
    stroke: "#3ad29f",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M650.35,205a7.27,7.27,0,0,1,3.23.2,7.05,7.05,0,0,1,1.42-.4c5.66-1,11.4,5.15,12.83,13.63s-2,16.14-7.65,17.09a7.27,7.27,0,0,1-3.23-.2,7.05,7.05,0,0,1-1.42.4c-5.66,1-11.4-5.15-12.83-13.63S644.7,205.94,650.35,205Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f55f44"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 654.8,
    cy: 246.95,
    rx: 4.45,
    ry: 8.9,
    transform: "translate(-211.71 385.23) rotate(-36.14)",
    fill: "#3ad29f"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 666.34,
    cy: 252.03,
    rx: 8.9,
    ry: 4.45,
    transform: "matrix(0.29, -0.96, 0.96, 0.29, 38.54, 767.18)",
    fill: "#3ad29f"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M647.42,258s15.58-5.19,26,0,20.77,0,31.16,0,0,10.39,15.58,10.39-46.74,46.74-26,103.86H663S683.77,325.48,647.42,258Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f5f5f5"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "460.11 157.06 461.9 162.42 462.89 156.36 460.11 157.06",
    opacity: 0.1
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "488.72 156.86 490.51 162.22 491.5 156.16 488.72 156.86",
    opacity: 0.1
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "515.03 157.56 515.97 163.14 517.88 157.3 515.03 157.56",
    opacity: 0.1
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "540.43 171.1 539.94 176.73 543.26 171.57 540.43 171.1",
    opacity: 0.1
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M665.59,256.49s9.84,42.92,9.84,59-2.68,56.33-2.68,56.33h3.58S672.74,263.64,671,257.38Z",
    transform: "translate(-192.07 -48.47)",
    opacity: 0.1
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M687.94,260.06S679,299.4,679,315.5s2.68,56.33,2.68,56.33h-3.58s2.68-104.61,4.47-110.87Z",
    transform: "translate(-192.07 -48.47)",
    opacity: 0.1
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M696,259.17s-9.84,40.23-9.84,56.33,2.68,56.33,2.68,56.33h-3.58s3.58-105.5,5.36-111.76Z",
    transform: "translate(-192.07 -48.47)",
    opacity: 0.1
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M697.7,312.61c-4.56-13.68-31.67,4.81-31.67,4.81l-2.23,3L615.6,385.58l-118.07-66V290.05a41,41,0,0,0,35.89-47.73c5.94-2.29,10.78-7.23,15.24-12,4.11-4.37,8.51-9.67,8.09-15.49a10.77,10.77,0,0,0-.16-2.78c-.94-4.91-5.38-8.49-10.08-10.2s-9.78-2-14.69-3c-11.7-2.29-22.27-8.4-33.68-11.86a76.62,76.62,0,0,0-15.91-3c-3.87-.32-7.9-.32-11.44,1.27-3.88,1.75-6.69,5.17-9.81,8.08a44.64,44.64,0,0,1-12.86,8.37c-7.07,3-15,4.23-21.37,8.47a12.61,12.61,0,0,0-4.31,4.32,11.74,11.74,0,0,0-1.15,6.14,30.79,30.79,0,0,0,.42,5.56c1.12,7.84,2.41,15.87,6.38,22.72,3.24,5.6,8.09,10.06,12.85,14.44l10.71,9.82c2.17,2,4.57,4.46,7.37,5.45-.18-1.3.56-2.67,1.66-4l-3.47,24.26a70.26,70.26,0,0,0-19.94-3.17c-9.12-.11-18.35,1.54-22.34,7.75a8.62,8.62,0,0,0-.61,1.18c-12.57,14.92-41.38,63.24-24.44,180.6-1.45,14.36-2.32,23.45-2.32,23.45l.1,1.44-.1,1.09.2.16L397.19,641,379,768.68H383v14.19h-4.56v22.8s63.34-4.05,73-18.24c8-11.77-31.82-7.15-45.61-5.23v-8.7h.25v-4.81h4.81L429.12,682c18.75-32.43,9.12-113.51,9.12-113.51L461,582.2l18.24,95.27L465.61,818.85h4.05v9.88h-5.32v22.8s63.34-4.05,73-18.24c8-11.77-31.8-7.15-45.59-5.23l-1.53-9.21H493l18.24-127.7c9-34.6-3.27-136.12-4.89-149.12l22.63-149.35-.32-.43.32-2.11,91.21,31.93s9.12,9.12,18.5-18c8.76-25.34,32.79-59.31,35.9-63.64l.33-.46S702.26,326.29,697.7,312.61Z",
    transform: "translate(-192.07 -48.47)",
    fill: "url(#f8a08d85-c1d3-485a-86b7-8b3df5ed85e7)"
  }))), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "195.01 709.2 195.01 731.4 217.21 731.4 217.21 700.31 195.01 709.2",
    fill: "#fda57d"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "279.39 753.61 279.39 780.25 301.6 775.81 297.16 749.17 279.39 753.61",
    fill: "#fda57d"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M422.85,304.9s-53,39.72-26.89,195.17Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#f55f44"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M422.85,304.9s-53,39.72-26.89,195.17Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#3ad29f"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "299.62 767.18 297.4 753.85 279.64 758.29 279.64 767.18 299.62 767.18",
    opacity: 0.05
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "195.25 718.32 217.46 718.32 217.46 705 195.25 713.88 195.25 718.32",
    opacity: 0.05
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "271 230.03 266.56 261.12 306.53 283.33 306.53 238.91 271 230.03",
    fill: "#fda57d"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M383.13,762.1l17.77-124.36L391.52,509,507,540s14.31,110.54,4.93,146.56L494.16,811H467.51l13.32-137.68-17.77-92.77-22.21-13.32s9.38,79-8.88,110.54L414.22,762.1Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#fbe1e5"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M693.52,318c-4.44-13.32-30.84,4.69-30.84,4.69l-2.17,2.94L671,345.08l.33-.45S698,331.3,693.52,318Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#fda57d"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M462.58,307.12s-35.53-9.38-44.41,4.44-26.65,199.86-26.65,199.86,52.8,44.41,115.47,31.09L529.2,395.95Z",
    transform: "translate(-192.07 -48.47)",
    opacity: 0.05
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M613.58,389,473.21,310.6a70.08,70.08,0,0,0-33.29-9c-8.88-.11-17.87,1.5-21.75,7.54C409.28,322.91,391.52,509,391.52,509S444.32,553.36,507,540L529.2,393.48,618,424.57s8.88,8.88,18-17.52c8.53-24.68,31.93-57.75,35-62L660.5,325.61Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#3ad29f"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M462.47,285.4a39.89,39.89,0,0,0,31.44,15.3,40.37,40.37,0,0,0,4.44-.25v-8.63l-35.53-8.88Z",
    transform: "translate(-192.07 -48.47)",
    opacity: 0.05
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 302.09,
    cy: 207.83,
    r: 39.97,
    fill: "#fda57d"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M382.63,775.92v22.21s61.68-3.95,71.06-17.77-48.85-4.44-48.85-4.44Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#333"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M466.28,820.58v22.21S528,838.84,537.34,825s-48.85-4.44-48.85-4.44Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#333"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M468.81,274.61l15.62-22.35c2.31-3.31,4.68-6.68,7.92-9.1s7.54-3.77,11.38-2.53c2.32.75,4.25,2.35,6.22,3.78,5.83,4.24,13,7.39,20.13,6.11,7.43-1.34,13.14-7.14,18.31-12.64,4.29-4.56,8.9-10.16,7.72-16.31-.92-4.78-5.24-8.26-9.82-9.93s-9.52-1.94-14.3-2.88c-11.39-2.23-21.69-8.18-32.8-11.55a74.61,74.61,0,0,0-15.5-3c-3.77-.31-7.7-.31-11.14,1.24-3.78,1.7-6.52,5-9.55,7.87a43.47,43.47,0,0,1-12.52,8.15c-6.88,2.94-14.57,4.12-20.81,8.25a12.28,12.28,0,0,0-4.19,4.21c-1.6,3-1.19,6.58-.71,9.92,1.09,7.63,2.34,15.45,6.21,22.12,3.16,5.45,7.87,9.8,12.52,14.06l10.43,9.57c2.11,1.94,4.45,4.34,7.18,5.31C460.62,281.48,466.84,277.43,468.81,274.61Z",
    transform: "translate(-192.07 -48.47)",
    opacity: 0.05
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M468.81,273.13l15.62-22.35c2.31-3.31,4.68-6.68,7.92-9.1s7.54-3.77,11.38-2.53c2.32.75,4.25,2.35,6.22,3.78,5.83,4.24,13,7.39,20.13,6.11,7.43-1.34,13.14-7.14,18.31-12.64,4.29-4.56,8.9-10.16,7.72-16.31-.92-4.78-5.24-8.26-9.82-9.93s-9.52-1.94-14.3-2.88c-11.39-2.23-21.69-8.18-32.8-11.55a74.61,74.61,0,0,0-15.5-3c-3.77-.31-7.7-.31-11.14,1.24-3.78,1.7-6.52,5-9.55,7.87A43.47,43.47,0,0,1,450.48,210c-6.88,2.94-14.57,4.12-20.81,8.25a12.28,12.28,0,0,0-4.19,4.21c-1.6,3-1.19,6.58-.71,9.92,1.09,7.63,2.34,15.45,6.21,22.12,3.16,5.45,7.87,9.8,12.52,14.06l10.43,9.57c2.11,1.94,4.45,4.34,7.18,5.31C460.62,280,466.84,275.95,468.81,273.13Z",
    transform: "translate(-192.07 -48.47)",
    fill: "#333"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropose);
export default __webpack_public_path__ + "static/media/propose.15cbf9849d9a8e9c3bf19b2791e83ddb.svg";
export { ForwardRef as ReactComponent };